import React from 'react';
import DataSourcesPage from './DataSourcesPage';

/**
 * Rockfall options.
 *
 * The odd one of the four families: these options were inline in the TrueContext form rather
 * than in a SharePoint lookup, so there is no export behind them and this page is the only way
 * to change them. They carry no code either - the value is what identifies an option, which is
 * why Code does not appear below.
 *
 * `type` is the question the option belongs to, picked from the list the rockfall datasource
 * actually serves. `rockfallVolume` is shared by two questions rather than belonging to one.
 */
const RockfallPage: React.FC = () => (
  <DataSourcesPage
    title="Rockfall"
    itemLabel="Option"
    addButtonLabel="Add Option"
    source="ROCKFALL"
    columns={[
      { key: 'type', label: 'Question' },
      { key: 'name', label: 'Option' },
      { key: 'label', label: 'Label' },
      { key: 'sortOrder', label: 'Order' },
      { key: 'isActive', label: 'Status' },
    ]}
    fields={[
      { key: 'type', label: 'Question', control: 'select', required: true },
      { key: 'name', label: 'Option', required: true, help: 'The value recorded on the entry.' },
      {
        key: 'label',
        label: 'Label',
        help: 'What the crew reads, where it differs from the option above. Leave blank to use the option.',
      },
      {
        key: 'sortOrder',
        label: 'Order',
        control: 'number',
        help: 'Position within its question. 0 sorts last.',
      },
      {
        key: 'isActive',
        label: 'Active',
        control: 'checkbox',
        help: 'Clear this to retire the option without deleting it, so historic entries still resolve.',
      },
    ]}
  />
);

export default RockfallPage;
